import React, { Component } from 'react';
import { Button, Card, Image, Grid, Header, Icon } from 'semantic-ui-react'
import { firebaseAuth, } from '../../../../config/constants.js';
import { getArtist } from '../algoliaDashboard/AlgoliaMiscUtils.js';
import * as UiConsts from '../../../../config/UiConstants'

import axios from 'axios'
import { serverIp } from '../../../../config/constants.js'

import createBrowserHistory from 'history/createBrowserHistory';
import ArtistDashboardUi from './ArtistDashboardUi.js';
const history = createBrowserHistory({ forceRefresh: true });


class ArtistDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            artistEmail: '',
            loggedInUser: '',
            artistInfo: [],
            invalidLogin: false,
            loginMessage: '',
            artistInfoObject: '',
            loading: true,
            dashboardInfo: ''
        }
    }

    componentDidMount() {
        console.log("artx1:+++++++: componentDidMount");
        console.log("artx11: this.props.match.params.artist:" + this.props.match.params.artist);

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
                console.log("artx12 user exists..");
                // let isAnonymous = user.isAnonymous;
                let uid = user.uid;
                console.log("artx13 uid:" + uid)
                console.log("artx14 email:" + user.email);

                if (user.email) {
                    console.log("artx141 email is valid");
                    getArtist(this.props.match.params.artist, this.getArtistDetails, user.email);

                    this.setState({
                        authed: true,
                        // loading: false,
                        user: user,
                        uid: user.uid,
                        //loading: false,
                        loggedInUser: user.email,
                    })
                } else {
                    console.log("artx142 NO EMAIL email is valid");
                    this.setState({
                        authed: false,
                        admin: false,
                        // loading: false,
                        user: user,
                        uid: user.uid,
                        loading: false,
                        loginMessage: "please login"
                    })

                    history.push('/artist/login')
                }

            } else {
                console.log("artx14 user DOES NOT exist..");
                this.setState({
                    authed: false,
                    loading: false
                })
            }
        })
    }

    getArtistDetails = (artistInfo, artistEmail) => {
        console.log("artx15 +++++++++: getArtistDetails");
        console.log("artx151 artistEmail:" + artistEmail);
        //let tempArtistInfo =  artistInfo;

        console.log("artx16 tempArtistInfo:" + JSON.stringify(artistInfo, null, 3));

        if (artistInfo && artistInfo.length === 0) {
            console.log("artx16 INVALID artist does not match:");
            this.setState({
                invalidLogin: true,
                loginMessage: "Unable to find artist with name:" + this.props.match.params.artist,
                loading: false
            })

            //THIS PART.. COMPARES THE USERS LOGGED IN EMAIL TO THE EMAIL ADDRESS FOUND IN ALGOLIA
        } else if (artistInfo && artistInfo.length === 1 && artistInfo[0].allowedEmails.indexOf(artistEmail.toLowerCase()) > -1) {
            console.log("artx1601 artistInfo[0].allowedEmails:" + artistInfo[0].allowedEmails);
            console.log("artx161 artistInfo[0].allowedEmails.indexOf(artistEmail.toLowerCase()):" + (artistInfo[0].allowedEmails.indexOf(artistEmail.toLowerCase()) > -1));
            console.log("artx17 artistInfo[0].email:" + artistInfo[0].email);
            this.setState({
                invalidLogin: false,
                loginMessage: 'SUCCESSFULL LOGIN',
                artistInfoObject: artistInfo[0],
                artistName: artistInfo[0].urlname
            });

            this.getArtistInfo(artistInfo[0]);
        } else if (artistInfo && artistInfo.length === 1 && artistInfo[0].allowedEmails.indexOf(artistEmail.toLowerCase()) === -1) {
            console.log("artx1601 artistInfo[0].allowedEmails:" + artistInfo[0].allowedEmails);
            console.log("artx161 artistInfo[0].allowedEmails.indexOf(artistEmail.toLowerCase()):" + (artistInfo[0].allowedEmails.indexOf(artistEmail.toLowerCase()) === -1));
            console.log("artx17 artistInfo[0].email:" + artistInfo[0].email);
            this.setState({
                invalidLogin: true,
                loginMessage: 'EMAIL:' + artistEmail + ' does not match artist info:' + this.props.match.params.artist,
                loading: false
            });
        }
    }


    getArtistInfo(artistInfoObject) {
        console.log("artx19 +++++++++: getArtistInfo");
        axios.post(serverIp + 'artists/getArtistInfo', {
            apiKey: artistInfoObject.apiKey,
            artistName: artistInfoObject.urlname,
            artistEmail: artistInfoObject.email,
            artistId: artistInfoObject.artistId
        })
            .then((response) => {
                console.log("artx192:" + JSON.stringify(response.data, null, 3));
                this.setState({
                    loading: false,
                    dashboardInfo: response.data
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    logout() {
        console.log("++++++++:mainAppLogout");
        firebaseAuth().signOut();

        history.push("artist/login");
    }

    render() {

        const invalidLoginUI = this.state.invalidLogin
            ? <h3>INVALID LOGIN DETAILS</h3>
            : ''

        const logoutButton = <Button onClick={this.logout} color='red'>LOGOUT</Button>

        const mainUi = this.state.dashboardInfo !== ''
            ? <ArtistDashboardUi artistInfoObject={this.state.artistInfoObject} dashboardInfo={this.state.dashboardInfo} />
            : ''

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> : <div>


                    {invalidLoginUI}

                    {mainUi}
                    {logoutButton}
        </div>);
    }
}

export default ArtistDashboard;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/artists/ArtistDashboard.js